import React from 'react';

import { Box, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { IServerOrder } from '@rbi-ctg/menu';

import { CardHeading, CardHeadingContainer, CardText } from '../styled';

const DeliveryInfo = ({ serverOrder }: { serverOrder: IServerOrder }) => {
  const { formatMessage } = useIntl();
  const { delivery, cart } = serverOrder;

  return (
    <CardHeadingContainer>
      <CardHeading>{formatMessage({ id: 'deliveryInfo' })}</CardHeading>

      <Box marginTop="$4">
        <CardText testID="order-confirmation-customer-name" data-private>
          {cart.customerName}
        </CardText>
        <CardText testID="order-confirmation-dropoff-address" data-private>
          {`${delivery?.dropoff.addressLine1}\n`}
          {!!delivery?.dropoff.addressLine2 && (
            <>
              {`${formatMessage(
                { id: 'unitNumber' },
                { unitNumber: delivery?.dropoff.addressLine2 }
              )}\n`}
            </>
          )}
          {delivery?.dropoff.city}, {delivery?.dropoff.state} {delivery?.dropoff.zip}
        </CardText>
        {!!delivery?.dropoff.phoneNumber && (
          <CardText testID="order-confirmation-phone-number" data-private>
            {delivery?.dropoff.phoneNumber}
          </CardText>
        )}
        {!!delivery?.instructions && (
          <CardText testID="order-confirmation-instructions" data-private marginTop={4}>
            <Text>{formatMessage({ id: 'deliveryInstructions' })}: </Text>
            {`\n${delivery?.instructions}`}
          </CardText>
        )}
      </Box>
    </CardHeadingContainer>
  );
};

export default DeliveryInfo;
